import { Component, Input } from '@angular/core';

@Component({
    selector: 'img-with-src-75px',
    template: `
        <img [hidden]="!value" class="app-image-fix-width-75px" [src]="value" />
    `,
    styles: [`
        .app-image-fix-width-75px {
            width: 75px;
            height: auto;
        }
    `]
})
export class ImgWithSrcComponentFixWidth75px {
    @Input()
    data: any = {};
    @Input()
    propertyName: string;
    public value: string | number;

    public ngOnInit() {
        this.value = this.data[this.propertyName];
    }
}
